import React, { useEffect, useState } from "react";

export function ReceiptSubmitIssue() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const iframe = document.getElementById("receipt-iframe");
    const handleLoad = () => setIsLoading(false);

    if (iframe) {
      iframe.addEventListener("load", handleLoad);
    }

    return () => {
      if (iframe) {
        iframe.removeEventListener("load", handleLoad);
      }
    };
  }, []);

  return (
    <div className="relative w-full h-[650px]">
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-md">
          <div className="animate-spin rounded-full size-12 border-y-2 border-blue-500"></div>
        </div>
      )}
      <iframe
        id="receipt-iframe"
        className={`airtable-embed size-full rounded-md ${
          isLoading ? "opacity-0" : "opacity-100"
        } transition-opacity duration-300`}
        src="https://airtable.com/embed/appQVgDXiCgnY2LfM/pagIy7yDFt5iJRb8c/form"
        frameBorder="0"
        style={{ background: "transparent", border: "1px solid #ccc" }}
        onLoad={() => setIsLoading(false)}
      ></iframe>
    </div>
  );
}
